import { FC } from "react";
import { Image } from "@chakra-ui/react";
import PinkConceiveLogo from "~/images/logos/pink_conceive.svg";

export const Logo: FC = () => {
  return (
    <Image
      alt="Pink Conceive logo"
      loading="lazy"
      h="6.25rem"
      py={6}
      src={PinkConceiveLogo}
      w="20rem"
    />
  );
};
